import * as React from 'react';

const SvgEmailClickIcon = props => {
  const { size = 24, fill } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      width={size}
      height={size}
      fill={fill}
      {...props}
    >
      <path
        d="M9.414 15.75H2.25a1.5 1.5 0 01-1.5-1.5v-12a1.5 1.5 0 011.5-1.5h18a1.5 1.5 0 011.5 1.5V9"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.411 1.3l-8.144 6.264a3.307 3.307 0 01-4.034 0L1.089 1.3M23.25 15.02v6.207a2.023 2.023 0 01-2.023 2.023h-4.033a3.016 3.016 0 01-2.141-.889L12 19.131a1.559 1.559 0 012.073-2.314l1.608 1.376v-4.93a1.5 1.5 0 011.927-1.434l4.211 1.271a2.009 2.009 0 011.431 1.92z"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgEmailClickIcon;
